import * as React from 'react';
import Dropzone from 'react-dropzone';
import {FilesAPI} from "../../api/FilesAPI";
import {ListItemSecondaryAction, ListItemText, ListItem, List, IconButton} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import {Upload} from "../../models/Upload";
import {DeleteConfirmation} from "../../tabs/components/DeleteConfirmation";
import {t} from "../localization";
import DocViewer, {DocViewerRenderers, PDFRenderer} from "react-doc-viewer";

export interface FileUploaderProps {
	itemId: string
	itemType: string
	uploads: Upload[]
	onUpload?: () => void
	onDelete?: () => void
}


export interface FileUploaderState {
	isDeleteConfirmationDialogOpen?: boolean;
	fileIdToDelete?: string
	previewDocs: any[]
}

class FileUploader extends React.Component<FileUploaderProps, FileUploaderState> {

	constructor(props: FileUploaderProps) {
		super(props);
		this.state = {isDeleteConfirmationDialogOpen: false, fileIdToDelete: null, previewDocs:[]}
	}

	componentDidMount () {

	}

	render (): React.ReactNode  {
		return <div>
			{this.renderDropZone()}
			{this.renderUploads()}
			{this.renderPreview()}
			{this.renderDeleteConfirmationDialog()}
		</div>
	}

	renderDropZone (): React.ReactNode {
		return <Dropzone onDrop={this.onDrop.bind(this)} >
			{({getRootProps, getInputProps}) => (
				<section className='ev-dropzone'>
					<div {...getRootProps()}>
						<input {...getInputProps()} />
						<p style={{textAlign: 'center', paddingTop: '20px'}}>{t.DragAndDropFiles}</p>
					</div>
				</section>
			)}
		</Dropzone>
	}

	renderUploads(): React.ReactNode {
		return <List dense={true}>
			{this.props.uploads && this.props.uploads.map((upload: Upload, key) => (
					<ListItem key={key} onClick={this.onSelectFile.bind(this, upload.id, upload.originalName)}>
						<ListItemText
							primary={upload.originalName}
							secondary={upload.createdAt}
						/>
						<ListItemSecondaryAction>
							<IconButton edge="end" aria-label="download" onClick={this.onDownloadClick.bind(this, upload.id, upload.originalName)}>
								<CloudDownloadIcon />
							</IconButton>
							<IconButton edge="end" aria-label="delete" onClick={this.openDeleteModal.bind(this, upload.id)}>
								<DeleteIcon />
							</IconButton>
						</ListItemSecondaryAction>
					</ListItem>
				))}
			</List>
	}

	renderPreview(): React.ReactNode {
		return (<div style={{}}>
			<DocViewer documents={this.state.previewDocs} pluginRenderers={DocViewerRenderers} />
		</div>)
	}

	renderDeleteConfirmationDialog(): React.ReactNode {
		return <DeleteConfirmation
			isOpen={this.state.isDeleteConfirmationDialogOpen}
			onDeleteConfirm={() => this.onDeleteConfirmClick()}
			onToggleModal={() => this.onToggleModal()}
		/>
	}

	onDeleteConfirmClick(){
		let api = new FilesAPI()
		api.deleteFile(this.state.fileIdToDelete).then(() => {
			if (this.props.onDelete) this.props.onDelete()
		})
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: false});
	}

	openDeleteModal(id: string) {
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: true, fileIdToDelete: id});
	}

	onToggleModal(){
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: !this.state.isDeleteConfirmationDialogOpen});
	}

	onSelectFile (id: string, fileName: string) {
		let api = new FilesAPI()
		this.setState({ ...this.state, previewDocs: [{uri: api.getFileForPreviewURL(id)}]});
	}

	private onDrop (acceptedFiles: File[]) {
		let props = this.props
		acceptedFiles.forEach(async (file) => {
			const reader = new FileReader()
			reader.onabort = () => console.log('file reading was aborted')
			reader.onerror = () => console.log('file reading has failed')
			reader.onload = () => {
				// Do whatever you want with the file contents
				const binaryStr = reader.result
				console.log(binaryStr)
				let api = new FilesAPI()
				// api.post({data: 'test', file: binaryStr})
			}
			await reader.readAsArrayBuffer(file)
			let api = new FilesAPI()
			api.uploadFile(file, props.itemId, props.itemType).then(() => {
				if (this.props.onUpload) this.props.onUpload()
			})
		})
	}

	private onDownloadClick (id: string, fileName: string) {
		console.log(id)
		let api = new FilesAPI()
		api.downloadFile(id).then((response:any) => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
			link.remove();// you need to remove that element which is created before.
		})
	}

}

export default FileUploader
